export const AMOUNT_1 = "amountM1";
export const AMOUNT_2 = "amountM2";
export const AMOUNT_3 = "amountM3";
export const AMOUNT_4 = "amountM4";
export const AMOUNT_5 = "amountM5";
export const AMOUNT_6 = "amountM6";
export const AMOUNT_7 = "amountM7";
export const AMOUNT_8 = "amountM8";
export const AMOUNT_9 = "amountM9";
export const AMOUNT_10 = "amountM10";
export const AMOUNT_11 = "amountM11";
export const AMOUNT_12 = "amountM12";
